import * as React from "react";
import Dashlet from "../../controls/Dashlet";
import EmptyPlaceholder from "../../controls/EmptyPlaceholder";
import { Button } from "../../controls/TooltipControls";
import { useTranslation } from "react-i18next";
function renderWebView(props) {
    const { entry } = props;
    return (React.createElement("div", { className: "dashlet-mod-spotlights-webview-container" },
        React.createElement("iframe", { ...{
                src: entry.link,
                sandbox: "allow-scripts allow-same-origin allow-presentation allow-forms allow-popups allow-popups-to-escape-sandbox",
                width: "100%",
                height: "335",
                frameBorder: "0",
                referrerPolicy: "strict-origin-when-cross-origin",
                allow: "encrypted-media; web-share; fullscreen",
                title: "YouTube video player",
                style: { border: 0 },
                allowFullScreen: true,
            } })));
}
function renderPlaceholder() {
    return (React.createElement("div", { className: "dashlet-mod-spotlights-webview-container" },
        React.createElement(EmptyPlaceholder, { icon: "video", text: "Our hamsters need a break..." })));
}
function NavButton(props) {
    const { entry, dir, onClick } = props;
    const [t] = useTranslation(["common"]);
    const classes = dir === "left"
        ? ["btn-ghost", "left", "smaller"]
        : ["btn-ghost", "right", "smaller"];
    return !entry ? null : (React.createElement(Button, { className: classes.join(" "), onClick: onClick, tooltip: t(dir === "left" ? "Previous Video" : "Next Video") }, dir === "left" ? "◄ " + `${t("Previous")}` : `${t("Next")}` + " ►"));
}
function renderInfo(t, entry) {
    return entry.id === "placeholder" ? null : (React.createElement("div", { className: "dashlet-mod-spotlights-info" },
        React.createElement("p", null, t("Here are some mods we think you should try out!")),
        React.createElement("p", { className: "youtube-privacy-notice" }, t("Playing this video will store cookies on your device"))));
}
export default function TopModsDashlet(props) {
    const [t] = useTranslation(["common"]);
    const [currentIdx, setIdx] = React.useState(-1);
    const [entries, setEntries] = React.useState([]);
    const [loaded, setLoaded] = React.useState(false);
    React.useEffect(() => {
        const runUpdate = async () => {
            const updated = await props.update();
            if (updated.length !== 0) {
                setEntries(updated);
                setIdx(Math.max(0, updated.length - 1));
                setLoaded(true);
            }
        };
        if (entries.length === 0) {
            runUpdate();
        }
    }, [entries]);
    const back = React.useCallback(() => {
        setIdx(Math.max(0, currentIdx - 1));
    }, [currentIdx]);
    const forward = React.useCallback(() => {
        setIdx(Math.min(entries.length - 1, currentIdx + 1));
    }, [currentIdx, entries]);
    return (React.createElement(Dashlet, { title: "Mods Spotlight", className: "dashlet-mod-spotlights" },
        loaded && renderInfo(t, entries?.[currentIdx]),
        loaded
            ? renderWebView({ entry: entries?.[currentIdx] })
            : renderPlaceholder(),
        React.createElement("div", { className: "dashlet-mod-spotlights-button-container" },
            React.createElement(NavButton, { entry: entries?.[currentIdx - 1], dir: "left", onClick: back }),
            React.createElement(NavButton, { entry: entries?.[currentIdx + 1], dir: "right", onClick: forward }))));
}
